import {KeyValuePipe, NgClass} from "@angular/common";
import {Component, output} from "@angular/core";
import {NgbDatepicker, NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {WeightMeasurementUnit} from "src/app/infrastructure/moovement-api/models/asset";
import {WeightMeasurementUnitPipe} from "src/app/presentation/common/pipes/WeightMeasurementUnitPipe";
import {FormsModule} from "@angular/forms";
import {AddWeightMeasurementRequest} from "src/app/infrastructure/moovement-api/web-api/animal.api-client";
import {parseOptionalFloat} from "src/app/domain/util/parsing/parsing";

interface PreviousInput {
    unit?: WeightMeasurementUnit
    date: NgbDateStruct
}

const now = new Date();
const today: NgbDateStruct = {
  year: now.getFullYear(),
  month: now.getMonth() + 1,
  day: now.getDate()
}

const previousInput: PreviousInput = {
  date: today
}

@Component({
  selector: 'app-create-weight-measurement',
  imports: [
    NgClass,
    WeightMeasurementUnitPipe,
    FormsModule,
    NgbDatepicker,
    KeyValuePipe
],
  templateUrl: './create-weight-measurement.component.html',
  styleUrl: './create-weight-measurement.component.css'
})
export class CreateWeightMeasurementComponent {

  weightMeasurementCreated = output<AddWeightMeasurementRequest | undefined>();

  protected date = previousInput.date;
  protected weight?: number;
  protected unit?: WeightMeasurementUnit = previousInput.unit;

  protected today = today;
  protected weightMeasurementUnits = WeightMeasurementUnit;

  setWeight(event: Event) {
    if (!event.target) return;

    const string = (event.target as HTMLInputElement).value;
    this.weight = parseOptionalFloat(string);

    this.emit();
  }

  setWeightMeasurementUnit(unit: WeightMeasurementUnit) {
    previousInput.unit = unit;
    this.unit = unit;

    this.emit();
  }

  setDate(date: NgbDateStruct) {
    previousInput.date = date;
    this.date = date;

    this.emit();
  }

  private emit() {
    if (!this.weight) {
      this.weightMeasurementCreated.emit(undefined);
      return;
    }

    if (!this.unit) return;

    this.weightMeasurementCreated.emit({
      weight: this.weight!,
      unit: this.unit!,
      submittedAt: new Date(this.date.year, this.date.month - 1, this.date.day)
    });
  }
}
